import { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import { login } from "../../../services/operations/authAPI";
import { DS } from "../../../utils/designSystem";

function LoginForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const { email, password } = formData;

  const handleOnChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    dispatch(login(email, password, navigate));
  };

  return (
    <form onSubmit={handleOnSubmit} className="flex flex-col gap-5">
      <div className="mb-1">
        <h2 className="text-2xl font-bold text-richblack-5">Welcome back</h2>
        <p className="mt-1 text-sm text-richblack-400">
          Sign in to continue your learning journey.
        </p>
      </div>

      {/* Email */}
      <div>
        <label htmlFor="lf-email" className={DS.input.label}>
          Email Address <sup className="text-pink-200">*</sup>
        </label>
        <input
          id="lf-email"
          required
          type="email"
          name="email"
          value={email}
          onChange={handleOnChange}
          placeholder="you@example.com"
          className={DS.input.base}
        />
      </div>

      {/* Password */}
      <div>
        <div className="mb-1.5 flex items-center justify-between">
          <label htmlFor="lf-password" className="text-sm font-medium text-richblack-200">
            Password <sup className="text-pink-200">*</sup>
          </label>
          <Link
            to="/forgot-password"
            className="text-xs text-yellow-50 transition-colors hover:text-yellow-25"
          >
            Forgot password?
          </Link>
        </div>
        <div className="relative">
          <input
            id="lf-password"
            required
            type={showPassword ? "text" : "password"}
            name="password"
            value={password}
            onChange={handleOnChange}
            placeholder="Enter your password"
            className={`${DS.input.base} pr-12`}
          />
          <button
            type="button"
            onClick={() => setShowPassword((prev) => !prev)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-richblack-400 transition-colors hover:text-richblack-200"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? (
              <AiOutlineEyeInvisible size={20} />
            ) : (
              <AiOutlineEye size={20} />
            )}
          </button>
        </div>
      </div>

      <button type="submit" className={`${DS.btn.primary} mt-1 w-full`}>
        Sign In
      </button>

      <p className="text-center text-sm text-richblack-400">
        Don't have an account?{" "}
        <Link
          to="/signup"
          className="font-medium text-yellow-50 transition-colors hover:text-yellow-25"
        >
          Sign up for free
        </Link>
      </p>
    </form>
  );
}

export default LoginForm;
